import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=74fa2dd2"
import script from "./tag.vue?vue&type=script&lang=js"
export * from "./tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74fa2dd2')) {
      api.createRecord('74fa2dd2', component.options)
    } else {
      api.reload('74fa2dd2', component.options)
    }
    module.hot.accept("./tag.vue?vue&type=template&id=74fa2dd2", function () {
      api.rerender('74fa2dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuickAdminTable/tag.vue"
export default component.exports